<h1 mat-dialog-title>
  {{(data.isNewShop ? 'administration.shops.add' : 'administration.shops.edit') | translate}}
  <div style="float: right">
    <fa-icon [icon]="data.isNewShop ? faShopAdd : faShopEdit"></fa-icon>
  </div>
</h1>
<mat-divider></mat-divider>
<form name="shopForm" [formGroup]="shopFormGroup">
  <div mat-dialog-content>

    <mat-form-field appearance="outline" color="primary" *ngIf="brands.length > 1"
      [ngClass]="{'selected-brand': brandFormControl.value}">
      <mat-label>{{'common.brand' | translate}}</mat-label>
      <mat-select [formControl]="brandFormControl" [disableOptionCentering]="true">
        <mat-select-trigger>
          <div class="brand">
            <img class="logo" [src]="brandService.getLogoById(brandFormControl.value)" />
            <span>{{getBrandName(brandFormControl.value)}}</span>
          </div>
        </mat-select-trigger>
        <mat-option *ngFor="let brand of brands" [value]="brand.id" class="select-brand-option">
          <div class="brand">
            <img class="logo" [src]="brandService.getLogo(brand.logo)" />
            <span>{{brand.name}}</span>
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="row">
      <mat-form-field appearance="outline" color="primary">
        <mat-label>{{'common.shop-name' | translate}}</mat-label>
        <input matInput name="shopName" [formControl]="shopNameFormControl" autocomplete="off" required>
        <mat-error *ngIf="shopNameFormControl.hasError('required')">
          {{'common.field-required' | translate}}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" color="primary">
        <mat-label>{{'common.shop-number' | translate}}</mat-label>
        <input matInput name="shopNumber" [formControl]="shopNumberFormControl" autocomplete="off" required>
        <mat-error *ngIf="shopNumberFormControl.hasError('required')">
          {{'common.field-required' | translate}}
        </mat-error>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" color="primary">
      <mat-label>{{'administration.shops.street' | translate}}</mat-label>
      <input matInput name="street" [formControl]="streetFormControl" autocomplete="off" required>
      <mat-error *ngIf="streetFormControl.hasError('required')">
        {{'common.field-required' | translate}}
      </mat-error>
    </mat-form-field>

    <div class="row">
      <mat-form-field appearance="outline" color="primary">
        <mat-label>{{'administration.shops.postcode' | translate}}</mat-label>
        <input matInput name="postcode" [formControl]="postcodeFormControl" autocomplete="off" required>
        <mat-error *ngIf="postcodeFormControl.hasError('required')">
          {{'common.field-required' | translate}}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" color="primary">
        <mat-label>{{'administration.shops.city' | translate}}</mat-label>
        <input matInput name="city" [formControl]="cityFormControl" autocomplete="off" required>
        <mat-error *ngIf="cityFormControl.hasError('required')">
          {{'common.field-required' | translate}}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field appearance="outline" color="primary">
        <mat-label>{{'administration.shops.phone-number' | translate}}</mat-label>
        <input matInput name="phoneNumber" [formControl]="phoneNumberFormControl" autocomplete="off">
        <mat-error *ngIf="phoneNumberFormControl.hasError('required')">
          {{'common.field-required' | translate}}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" color="primary">
        <mat-label>{{'administration.shops.email' | translate}}</mat-label>
        <input matInput name="emailAddress" [formControl]="emailAddressFormControl" autocomplete="off">
        <mat-error *ngIf="emailAddressFormControl.hasError('required')">
          {{'common.field-required' | translate}}
        </mat-error>
      </mat-form-field>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-actions align="end">
    <button mat-button (click)="onNoClick()" type="button" color="warn">{{'common.cancel' | translate}}</button>
    <button mat-button (click)="onOkClick()" type="submit" [mat-dialog-close]="data" [disabled]="!shopFormGroup.valid"
      color="accent">{{'common.save' | translate}}</button>
  </div>
</form>